import { useTheme } from '@mui/material';
import { useLineageGraphContext } from '../LineageGraphContext';
import type { LineageNodeColors, ReactFlowNodeData } from '../types';
import {
  getLineageCategoryColors,
  getLineageColorCategory,
} from '../utils/lineageDisplaySettings';

/** A node's colors under the active "Color by" setting. */
const useLineageNodeColors = (data?: ReactFlowNodeData): LineageNodeColors => {
  const theme = useTheme();
  const { displaySettings } = useLineageGraphContext();
  return getLineageCategoryColors(
    theme.palette,
    getLineageColorCategory(displaySettings.colorBy, data),
  );
};

export default useLineageNodeColors;
